<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Process',
  data () {
    return {
      // 第一行节点：1(0)、2(1)、3(2)
      row1Nodes: [
        { icon: require('../assets/image/process/icon1.png'), aicon: require('../assets/image/process/icon1a.png'), label: '接受委托<br>阶段', isVisible: false, isActive: false,
          isOpen: false,
          children: [
            { label: '1、签订代理协议', children:[
                {label:'代理协议模板',file: require('../assets/files/1 接受委托阶段/1、签订代理协议/代理协议模板.docx')},
                {label:'相关政策依据',file: require('../assets/files/1 接受委托阶段/1、签订代理协议/相关政策依据.docx')}
              ]},
            { label: '2、开展采购需求调查', children:[
                {label:'相关政策依据',file: require('../assets/files/1 接受委托阶段/3、发布采购意向公告/‭相关政策依据.docx')},
                {label:'意向公示模板',file: require('../assets/files/1 接受委托阶段/3、发布采购意向公告/意向公示模板.docx')},
              ]},
            { label: '3、发布采购意向公告', children:[
                {label:'相关政策依据',file: require('../assets/files/1 接受委托阶段/2、开展采购需求调查/相关政策依据.docx')},
                {label:'需求调研模板',file: require('../assets/files/1 接受委托阶段/2、开展采购需求调查/需求调研模板.docx')},
              ]},
            { label: '4、采购方式选择', children:[
                {label:'确定政府采购方式流程图',file: require('../assets/files/1 接受委托阶段/4、采购方式选择/确定政府采购方式流程图.docx')},
              ]},
          ]
        },
        { icon: require('../assets/image/process/icon2.png'), aicon: require('../assets/image/process/icon2a.png'), label: '招标文件<br>编制', isVisible: false, isActive: false,
          isOpen: false,
          children: [
            { label: '1、招标文件模板', children:[
                {label:'单一来源',file: require('../assets/files/2 招标文件编制/1、招标文件模板/单一来源.docx')},
                {label:'公开开招标(服务)',file: require('../assets/files/2 招标文件编制/1、招标文件模板/公开开招标(服务).docx')},
                {label:'公开开招标(货物)',file: require('../assets/files/2 招标文件编制/1、招标文件模板/公开开招标(货物).docx')},
                {label:'竞争性磋商(服务)',file: require('../assets/files/2 招标文件编制/1、招标文件模板/竞争性磋商(服务).docx')}
              ]},
            { label: '2、采购文件审核', children:[
                {label:'相关政策规定',file: require('../assets/files/2 招标文件编制/2、采购文件审核/相关政策规定.doc')},
                {label:'审核流程',file: require('../assets/files/2 招标文件编制/2、采购文件审核/审核流程.docx')},
                {label:'项目流转表',file: require('../assets/files/2 招标文件编制/2、采购文件审核/项目流转表.docx')},
              ]}
          ]},
        { icon: require('../assets/image/process/icon3.png'), aicon: require('../assets/image/process/icon3a.png'), label: '采购组织<br>阶段', isVisible: false, isActive: false,
          isOpen: false,
          children: [
            { label: '1、发布采购公告', children:[
                {label:'相关政策依据',file: require('../assets/files/3 采购组织阶段/1、发布采购公告/相关政策依据.docx')},
                {label:'招标公示模板',file: require('../assets/files/3 采购组织阶段/1、发布采购公告/招标公示模板.docx')}
              ]},
            { label: '2、投标报名', children:[
                {label:'相关政策依据',file: require('../assets/files/3 采购组织阶段/2、投标报名/相关政策依据.docx')},
              ]},
            { label: '3、质疑答复处理', children:[
                {label:'质疑答复模板',file: require('../assets/files/3 采购组织阶段/3、质疑答复处理/质疑答复模板.docx')},
                {label:'论证模板',file: require('../assets/files/3 采购组织阶段/3、质疑答复处理/论证模板.docx')},
                {label:'政府采购质疑和投诉办法',file: require('../assets/files/3 采购组织阶段/3、质疑答复处理/政府采购质疑和投诉办法.docx')},
              ]},
            { label: '4、专家抽取', children:[
                {label:'抽取流程',file: require('../assets/files/3 采购组织阶段/4、专家抽取/抽取流程.docx')},
              ]},
            { label: '5、推广异地评标', children:[
                {label:'相关政策依据',file: require('../assets/files/3 采购组织阶段/5、推广异地评标/相关政策依据.doc')},
              ]},
          ]
        }
      ],
      // 第二行节点：4(3)、5(4) → 显示时先5后4
      row2Nodes: [
        { icon: require('../assets/image/process/icon4.png'), aicon: require('../assets/image/process/icon4a.png'), label: '资料归档<br>及交接', isVisible: false, isActive: false,
          isOpen: false,
          children:[
            {label:'主持开标',file: require('../assets/files/4 开评标阶段/1.主持开标.docx')},
            {label:'评标活动组织',file: require('../assets/files/4 开评标阶段/2.评标活动组织.docx')},
            {label:'相关政策依据',file: require('../assets/files/4 开评标阶段/3.相关政策依据.docx')},
          ]},
        { icon: require('../assets/image/process/icon5.png'), aicon: require('../assets/image/process/icon5a.png'), label: '开评标<br>阶段', isVisible: false, isActive: false,
          isOpen: false,
          children:[
            {label:'相关政策依据',file: require('../assets/files/5 结果公布阶段/相关政策依据.docx')},
            {label:'结果公告',file: require('../assets/files/5 结果公布阶段/结果公告.docx')}
          ]}
      ],
      // 第三行节点：6(5)、7(6)、8(7)
      row3Nodes: [
        { icon: require('../assets/image/process/icon6.png'), aicon: require('../assets/image/process/icon6a.png'), label: '履约验收', isVisible: false, isActive: false,
          isOpen: false,
          children:[
            {label:'合同公告模板',file: require('../assets/files/6 合同备案/合同公告模板.docx')}
          ]},
        { icon: require('../assets/image/process/icon7.png'), aicon: require('../assets/image/process/icon7a.png'), label: '合同备案', isVisible: false, isActive: false,
          isOpen: false,
          children:[
            {label:'相关政策依据',file: require('../assets/files/7 履约验收/相关政策依据.docx')},
            {label:'验收模板及流程',file: require('../assets/files/7 履约验收/验收模板及流程.docx')}
          ]},
        { icon: require('../assets/image/process/icon8.png'), aicon: require('../assets/image/process/icon8a.png'), label: '结果公布<br>阶段', isVisible: false, isActive: false,
          isOpen: false,
          children:[
            {label:'相关政策依据',file: require('../assets/files/8 资料归档及交接/相关政策依据.docx')},
            {label:'资料交接',file: require('../assets/files/8 资料归档及交接/资料交接.docx')}
          ]}
      ],
      allNodes: [], // 存储所有节点的统一数组
      activeIndex: -1, // 当前高亮的节点索引
      // S型显示的自定义顺序（对应allNodes的原始索引）：1→2→3→5→4→6→7→8
      sOrder: [0, 1, 2, 4, 3, 5, 6, 7],
      dialogVisible: false,
      docList: []
    }
  },
  mounted () {
    // 合并所有节点为一个数组，方便统一控制
    this.allNodes = [
      ...this.row1Nodes,
      ...this.row2Nodes,
      ...this.row3Nodes
    ]
    // 调用S型逐个显示并高亮的方法，间隔800ms（可自定义）
    this.showAndHighlightBySOrder(1000)
  },
  methods: {
    toggleExpand(item) {
      this.$set(item, 'isOpen', !item.isOpen);
    },
    toLook(item) {
      this.$router.push({
        path: '/processDocx',
        query: {
          url: item.file
        }
      })
    },

    openLayer(item, index) {
      this.dialogVisible = true;
      // 为每个项目添加展开状态
      this.docList = item.children.map(child => ({
        ...child,
        isOpen: false
      }));
    },
    toDetail (item) {
      this.$router.push({
        path: '/processPdf',
        query: {
          id: 1
        }
      })
    },
    /**
     * 按S型顺序逐个显示节点并动态高亮
     * @param {Number} interval 间隔时间(ms)
     */
    showAndHighlightBySOrder (interval) {
      this.sOrder.forEach((nodeIndex, orderIndex) => {
        setTimeout(() => {
          // 1. 取消上一个节点的高亮
          if (this.activeIndex !== -1) {
            this.$set(this.allNodes[this.activeIndex], 'isActive', false)
          }
          // 2. 显示当前S顺序的节点
          this.$set(this.allNodes[nodeIndex], 'isVisible', true)
          // 3. 高亮当前S顺序的节点
          this.$set(this.allNodes[nodeIndex], 'isActive', true)
          // 4. 更新当前高亮的原始节点索引
          this.activeIndex = nodeIndex

          // 可选：最后一个节点高亮保持的额外逻辑
          if (orderIndex === this.sOrder.length - 1) {
            console.log('S型显示完成，最后一个节点保持高亮')
          }
        }, orderIndex * interval)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mainBox {
  .title-section {
    text-align: center;
    padding-top: 50px;
    padding-bottom: 24px;

    h1 {
      font-weight: 500;
      font-size: 60px;
      color: #08141D;
      text-align: center;
      margin-bottom: 30px;
    }
  }
}

.process-nodes {
  margin: 120px 120px 80px;
  width: 1500px;
  height: 550px;
  background-image: url("../assets/image/process/lineBg.png");
  background-size: 100% 100%;
  position: relative;
}

/* 节点行容器 */
.node-row {
  display: flex;
  align-items: center;
  position: relative;

  &.one {
    margin-left: 60px;
    top: -90px;
  }

  &.two {
    justify-content: center;
    right: 20px;
    top: -10px;
  }

  &.three {
    width: 80%;
    justify-content: center;
    right: -300px;
    top: 60px;
  }
}

/* 节点项样式 - 初始状态（隐藏+缩小+透明） */
.node-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 170px;
  height: 170px;
  box-shadow: 0px 0px 30px 0px #008dff4f, inset 2px 0px 0px 0px #FFFFFF;
  border-radius: 50%;
  background-color: #ffffff;
  justify-content: center;
  font-size: 24px;
  color: #409eff;
  margin: 0 80px;
  /* 初始状态：透明+缩小+隐藏 */
  opacity: 0;
  transform: scale(0.8);
  visibility: hidden;
  /* 过渡动画：0.5s平滑过渡 */
  transition: all 0.5s ease-out;

  // 高亮状态样式
  &.node-active {
    background: linear-gradient(180deg, #9ED3FE, #068FFF);
    box-shadow: 0px 0px 30px 0px #008DFF;
    border: 2px solid #FFFFFF;

    .node-label {
      color: #fff;
    }
  }

  // 显示状态样式
  &.show {
    opacity: 1;
    transform: scale(1);
    visibility: visible;
  }

  img {
    width: 42px;
    height: 42px;
    margin-bottom: 10px;
  }

  .node-label {
    font-weight: 500;
    font-size: 28px;
    color: #08141D;
    line-height: 34px;
    text-align: center;
  }
}
.layer-dialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
 .el-icon-document{
   font-size: 26px;
   color: #44a3f5;
   margin-right: 10px;
  }
  .arrow{
    font-size: 26px;
    color: #44a3f5;
    padding: 0 30px;
  }
  .box {
    position: absolute;
    width: 800px;
    height: 600px;
    background: #FFFFFF;
    border-radius: 24px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }
  .top {
    background: linear-gradient( to right, #44a3f5 0%, #44a3f5 32%, #F4F5F9 93%, transparent 100%);
    padding: 20px;
    font-size: 28px;
    font-weight: 600;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-icon-error{
      color: #000;
      font-size: 30px;
    }
  }
  .doc-list {
    height: 500px;
    overflow: auto;
    list-style-type: disc;
    list-style-position: inside; /* 圆点在列表项内 */
    padding: 20px 30px;
    .doc-item {
      border-bottom: 1px solid  #D2D7E3;
      //display: flex;
      //justify-content: space-between;
      //align-items: center;
      padding-top: 20px;
      padding-bottom: 20px;
      position: relative;
      .item-left {
        width: 80%;
        display: flex;
        //flex-direction: column;
        .doc-content {
          flex: 1;
          white-space: pre-line; /* 支持换行 */
          font-weight: 550;
          font-size: 24px;
          color: #000000;
        }
        .doc-year {
          font-weight: 400;
          font-size: 20px;
          color: #708A9F;
          text-align: left;
          margin-top: 10px;
        }
      }
      .look {
        width: 100px;
        height: 50px;
        background: #CCE8FF;
        border-radius: 8px;
        border: 1px solid #008DFF;
        font-weight: 400;
        font-size: 22px;
        color: #08141D;
        line-height: 50px;
        text-align: center;
      }

    }
  }
}
</style>
